import type { FC } from 'react';
import { useContext } from 'react';

import { RiskDescriptions } from '@src/common-components/risk-descriptions';
import { Store } from '@src/store';

export const PetsRiskDescriptions: FC = () => {
  const {
    state: {
      stateFormPets: { risks, risksPage },
    },
  } = useContext(Store);

  return <RiskDescriptions risks={risks} risksPage={risksPage} />;
};
